export type DiagramConnectorLabelProps = {
  x: number;
  y: number;
  text: string;
  fill?: string;
  className?: string;
  paddingX?: number;
  paddingY?: number;
};

export function DiagramConnectorLabel({
  x,
  y,
  text,
  fill = "currentColor",
  className = "text-[11px] font-mono font-bold",
  paddingX = 6,
  paddingY = 3,
}: DiagramConnectorLabelProps) {
  // Approximate width based on character count for text-anchor="middle"
  const approxCharWidth = 6.8;
  const rectWidth = text.length * approxCharWidth + paddingX * 2;
  const rectHeight = 14 + paddingY * 2;
  const rectX = x - rectWidth / 2;
  const rectY = y - rectHeight / 2;

  return (
    <g>
      <rect
        x={rectX}
        y={rectY}
        width={rectWidth}
        height={rectHeight}
        rx="3"
        fill="var(--ga-paper-strong, #ffffff)"
        opacity="0.92"
      />
      <text
        x={x}
        y={y}
        textAnchor="middle"
        dominantBaseline="middle"
        fill={fill}
        className={className}
      >
        {text}
      </text>
    </g>
  );
}
